/* eslint-disable camelcase */
/* eslint-disable no-restricted-globals */
import "./Comment.scss";
import React from "react";
import { getUploadUrl } from "../../services/uploads";

type Props = {
    avatar_url?: string;
    text?: string;
    username?: string;
    file?: string;
    filename?: string;
};

export const Comment = (props: Props) => (
    <div className="comment">
        <div className="img-col">
            <img alt="user avatar" src={getUploadUrl(props.avatar_url || "")} />
        </div>
        <div className="comment-col">
            <div className="username">{props.username}</div>
            <p className="comment-text">{props.text}</p>
            <a
                target="_blank"
                rel="noreferrer"
                href={getUploadUrl(props.file || "")}
                className="comment-file"
            >
                {props.filename}
            </a>
        </div>
    </div>
);
